export class LocalStorage {
  setItem = (key, value) => localStorage.setItem(key, JSON.stringify(value))

  removeItem = key => localStorage.removeItem(key)

  getItem = key => {
    const item = localStorage?.getItem(key)
    return item !== 'undefined'
      ? JSON.parse(item) !== undefined
        ? JSON.parse(item)
        : null
      : localStorage.removeItem(key)
  }

  clear = () => localStorage.clear()

  cleanTokens = () => {
    localStorage.removeItem('refresh')
    localStorage.removeItem('token')
  }
}

export default new LocalStorage()
